import './LayoutView.scss';

export { default } from './LayoutView';
